export const getDefaultState = () => ({
  survey: null,
  surveys: [],
  deletedItems: [], // Save the array of deleted items that has uuid to delete only when save survey
  teamsPermission: [],
  userTeams: [],
  categories: [],
  integrations: [],
  queryParams: {},
  selectedSurveyItemIndex: null,
  report: {}
});

export default {
  survey: null,
  surveys: [],
  deletedItems: [], // Save the array of deleted items that has uuid to delete only when save survey
  teamsPermission: [],
  userTeams: [],
  categories: [],
  integrations: [],
  queryParams: {
    sortBy: "created_at",
    page: 1,
    descending: true,
    rowsPerPage: 15,
    startRow: 0,
    rowsNumber: 0,
    "filter.created_at.starts_at": null,
    "filter.created_at.ends_at": null,
    "filter.status.equal": null
  },
  selectedSurveyItemIndex: null,
  report: {}
};
